import {
    Box,
    Typography
} from '@mui/material';

export function MessageNotification(params: { message: string }) {
    return (

        <Box display="flex" alignItems="center" justifyContent="center" sx={{ p: 0, textAlign: "center", marginTop: "8px" }}>
            <Typography color="text.secondary" fontStyle="italic">
                {params.message}
            </Typography>
        </Box>
    );
}
